export var AuthenticationMethodType;
(function (AuthenticationMethodType) {
    AuthenticationMethodType["LVLR"] = "LVLR";
    AuthenticationMethodType["SMS_OTP"] = "SMS_OTP";
    AuthenticationMethodType["EMAIL_OTP"] = "EMAIL_OTP";
    AuthenticationMethodType["APP_OTP"] = "APP_OTP";
    AuthenticationMethodType["THREE_DS"] = "3DS";
    AuthenticationMethodType["CSC_VALIDATION"] = "CSC_VALIDATION";
    AuthenticationMethodType["APP_AUTHENTICATON"] = "APP_AUTHENTICATON";
    AuthenticationMethodType["ADDRESS_VERIFICATION"] = "ADDRESS_VERIFICATION";
    AuthenticationMethodType["FIDO2"] = "FIDO2";
    AuthenticationMethodType["SPC"] = "SPC";
    AuthenticationMethodType["MANAGED_AUTHENTICATION"] = "MANAGED_AUTHENTICATION";
})(AuthenticationMethodType || (AuthenticationMethodType = {}));
//# sourceMappingURL=AuthenticationMethodType.js.map